import { Component, inject } from '@angular/core';
import { EigeneZaehlerAntraegeAuflistenGQL } from '../../generated/graphql';
import { rxResource } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle, faTimesCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import { LuxonModule } from 'luxon-angular';

@Component({
  selector: 'app-liste-zaehler-antraege-component',
  imports: [
    FontAwesomeModule,
    LuxonModule,
  ],
  templateUrl: './liste-zaehler-antraege-component.html',
  styleUrl: './liste-zaehler-antraege-component.css',
})
export class ListeZaehlerAntraegeComponent {

  private readonly eigeneZaehlerAntraegeAuflistenGQL = inject(EigeneZaehlerAntraegeAuflistenGQL);

  readonly faCheckCircle = faCheckCircle;
  readonly faTimesCircle = faTimesCircle;
  readonly faClock = faClock;

  protected readonly eiegeneZaehlerAntraege = rxResource({
    params: () => ({}),
    stream: ({params}) => this.eigeneZaehlerAntraegeAuflistenGQL.fetch().pipe(map((result) => result?.data?.eigeneZaehlerAntraegeAuflisten || [])),
  });

  getStatusClass(genehmigt: boolean | null | undefined, abgelehnt: boolean | null | undefined): string {
    if (abgelehnt === true) return 'bg-red-50';
    if (genehmigt === true) return 'bg-green-50';
    return 'bg-blue-50';
  }

  getStatusLabel(genehmigt: boolean | null | undefined, abgelehnt: boolean | null | undefined): string {
    if (abgelehnt === true) return 'Abgelehnt';
    if (genehmigt === true) return 'Genehmigt';
    return 'In Bearbeitung';
  }

  getStatusIcon(genehmigt: boolean | null | undefined, abgelehnt: boolean | null | undefined) {
    if (abgelehnt === true) return this.faTimesCircle;
    if (genehmigt === true) return this.faCheckCircle;
    return this.faClock;
  }

  getStatusIconClass(genehmigt: boolean | null | undefined, abgelehnt: boolean | null | undefined): string {
    if (abgelehnt === true) return 'text-red-600';
    if (genehmigt === true) return 'text-green-600';
    return 'text-blue-600';
  }

  getStatusBadgeClass(genehmigt: boolean | null | undefined, abgelehnt: boolean | null | undefined): string {
    if (abgelehnt === true) return 'bg-red-100 text-red-700';
    if (genehmigt === true) return 'bg-green-100 text-green-700';
    return 'bg-blue-100 text-blue-700';
  }
}
